module.exports = __webpack_public_path__ + "img/32931-055.edd5f415.jpg";